export default "__VITE_PUBLIC_ASSET__139ffe85__"